module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Semibold.288360ada48b64cd21bbd1f22c4d8925.ttf";